import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextArea from 'react-textarea-autosize';
import MessageEditControls from './MessageEditControls';
import config from "../../../../../../../../config";
import {handleChange} from "../../../../../../../../utils/ComponentUtilFunctions";
import Switch from "../../../../../../../../components-new/form/Switch";
import './HardcodedMessages.css';

class TextMessageEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            currentValue: '',
            statuses: {}
        };

        this.handleChange = handleChange.bind(this);
        this.textareaRef = React.createRef();
    }

    handleEditIconClick = () => {
        const {value} = this.props;
        this.setState({
            editing: true,
            currentValue: value,
        }, () => {
            window.requestAnimationFrame(() => {
                const textarea = this.textareaRef.current;
                if (!textarea) return;

                const end = textarea.value.length;
                textarea.focus();
                textarea.setSelectionRange(end, end);
            });
        });
    };

    handleCancel = () => {
        this.setState({
            editing: false,
            currentValue: '',
        });
    };

    handleSave = () => {
        const {updateMessage} = this.props;
        const {currentValue} = this.state;
        return updateMessage(currentValue).then(this.setState({
            editing: false,
            currentValue: '',
        }));
    };

    render() {
        const {editing, currentValue} = this.state;
        const {value, hardCodedMessagesStatusData, type, handleCheckboxChange} = this.props;

        const displayValue = type === config.hardCodedMessagesTypesMap.operatorJoinedText
            ? "'Operator name' " + value
            : value;

        const textView = editing ? (
            <TextArea
                inputRef={this.textareaRef}
                className="hcm-textarea"
                onChange={this.handleChange('currentValue')}
                value={currentValue}
            />
        ) : (
            <div className={'hcm-card__body' + (displayValue ? '' : ' hcm-card__body--muted')}>
                {displayValue || '—'}
            </div>
        );

        return (
            <div className="hcm-card">
                {editing ? <div className="hcm-card__body">{textView}</div> : textView}

                <div className="hcm-card__controls">
                    {/* while editing the row already shows save/cancel — a third
                        control there just competes for attention */}
                    {!editing && (
                        <Switch
                            checked={hardCodedMessagesStatusData[type] ? hardCodedMessagesStatusData[type] : false}
                            onChange={() => handleCheckboxChange(type)}
                        />
                    )}
                    <MessageEditControls
                        editing={editing}
                        handleEditIconClick={this.handleEditIconClick}
                        handleCancel={this.handleCancel}
                        handleSave={this.handleSave}
                    />
                </div>
            </div>
        );
    }
}

TextMessageEdit.propTypes = {
    value: PropTypes.string.isRequired,
    updateMessage: PropTypes.func.isRequired,
};

export default TextMessageEdit;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/TextMessageEdit.jsx